export default __webpack_public_path__ + "static/media/uber.fafebfc6.png";